import React, { useCallback, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { Imposter } from '@hub/imposter'
import { Cover } from '@hub/cover'

export interface IRouteChangingProps {
  fallback: React.ComponentType
}

const RouteChangeIndicator: React.FunctionComponent<IRouteChangingProps> = function RouteChangeIndicator({
  fallback: Fallback,
  children,
}) {
  const router = useRouter()
  const [isRouteChanging, setRouteChanging] = useState(false)

  const routeChangeStart = useCallback(
    (_url, { shallow }): void => {
      if (!shallow) {
        setRouteChanging(true)
      }
    },
    [setRouteChanging]
  )

  const routeChangeCompleteOrError = useCallback((): void => {
    setRouteChanging(false)
  }, [setRouteChanging])

  useEffect(() => {
    router.events.on('routeChangeStart', routeChangeStart)
    router.events.on('routeChangeComplete', routeChangeCompleteOrError)
    router.events.on('routeChangeError', routeChangeCompleteOrError)

    return () => {
      router.events.off('routeChangeStart', routeChangeStart)
      router.events.off('routeChangeComplete', routeChangeCompleteOrError)
      router.events.off('routeChangeError', routeChangeCompleteOrError)
    }
  }, [router, routeChangeStart, routeChangeCompleteOrError])

  return (
    <Imposter
      impose={
        isRouteChanging ? (
          <Cover sx={{ zIndex: 'popover' }} backgroundColor="white">
            <Fallback />
          </Cover>
        ) : undefined
      }
      sx={{ height: '100%' }}
    >
      {children}
    </Imposter>
  )
}

export default RouteChangeIndicator
